var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"navbar box-shadow btborder noprint"},[_c('div',{staticClass:"container d-flex justify-content-between"},[_c('router-link',{staticClass:"navbar-brand d-flex align-items-center",attrs:{"to":{ name: 'dashboard' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }